import { postRequest } from '../../utils'
import { authServiceUrl } from '../../urls'

export const postLoginReq = (username, password) => postRequest(`${authServiceUrl}/admin/auth/login`, { username, password })

export const postLogoutReq = () => postRequest(`${authServiceUrl}/admin/auth/logout`, {})
